<ng-container [ngSwitch]="type">
    <bazis-button
        *ngSwitchCase="'button'"
        fill="clear"
        [href]="href"
        [target]="target"
        [size]="buttonSize"
    >
        <bazis-icon
            slot="icon-only"
            src="/assets/icons/other/open.svg"
        ></bazis-icon>
    </bazis-button>

    <ng-container *ngSwitchCase="'link'">
        @if (target === '_blank') {
            <bazis-link
                [size]="
                    linkSize === 'regular' ? 'regular' : linkSize === 'compact' ? 'compact' : ''
                "
                borderStyle="none"
                [href]="href"
                [target]="target"
            >
                <ng-content></ng-content>
                <bazis-icon
                    slot="end"
                    [size]="linkSize === 'regular' ? 'regular' : 'huge'"
                    src="/assets/icons/other/open.svg"
                ></bazis-icon>
            </bazis-link>
        } @else {
            <bazis-link
                [size]="
                    linkSize === 'regular' ? 'regular' : linkSize === 'compact' ? 'compact' : ''
                "
                borderStyle="none"
                [routerLink]="href"
            >
                <ng-content></ng-content>
                <bazis-icon
                    slot="end"
                    [size]="linkSize === 'regular' ? 'regular' : 'huge'"
                    src="/assets/icons/other/open.svg"
                ></bazis-icon>
            </bazis-link>
        }
    </ng-container>

    <bazis-icon
        *ngSwitchCase="'icon'"
        src="/assets/icons/other/open.svg"
        size="compact"
        class="bh-pointer bazis-text_placeholder"
        [routerLink]="href"
        [target]="target"
    ></bazis-icon>
</ng-container>
